import { createAction, props } from '@ngrx/store';
import { Mls } from 'app/models/mls';

export const mlsesFetched = createAction('MLSES_FETCHED', props<{ mlses: Mls[] }>());
